import { Component, inject } from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-sign-error-dialog',
  imports: [Button],
  templateUrl: './sign-error-dialog.html',
  styleUrl: './sign-error-dialog.scss',
})
export class SignErrorDialog {
  protected readonly dynamicDialogRef = inject(DynamicDialogRef);

  onCloseAndReload(): void {
    this.dynamicDialogRef.close();
    // Opóźnienie pozwalające zamknąć dialog przed reload
    setTimeout(() => location.reload(), 100);
  }
}
